// Reading the partner link signals out of the browser.
//
// Two signals exist: the slug on the referral address (?red=jane) and the
// tracking cookie the partner script drops on first visit. The cookie is
// the one that survives a walk around the marketing pages before signup.

/** The referral slug on the current address, if any. */
export function readAffiliateSlug(search: string): string | null {
  try {
    const params = new URLSearchParams(search);
    const value = params.get("red") ?? params.get("gr_affiliate");
    const trimmed = (value ?? "").trim().slice(0, 120);
    return trimmed || null;
  } catch {
    return null;
  }
}

/** The partner tracking cookie id, read from a raw cookie string. */
export function readGrCookieId(cookie: string): string | null {
  const parts = cookie.split(";");
  let fallback: string | null = null;
  for (const part of parts) {
    const eq = part.indexOf("=");
    if (eq < 0) continue;
    const name = part.slice(0, eq).trim();
    const value = decodeURIComponent(part.slice(eq + 1).trim()).slice(0, 200);
    if (!value) continue;
    if (name === "gr_id") return value;
    if (!fallback && name.startsWith("gr_")) fallback = value;
  }
  return fallback;
}
